import React from "react";
import { useTranslation } from "react-i18next";
import { SubMenuLink } from "../subSolutions";

import "./subSuporteMob.scss"

const SubSuporteMob = () => {
    const { t } = useTranslation()

    return (
        <div className="container-submenuSuporteMob">
            <div className="submenu-SuporteMob">
                <div style={{ display: "flex" }}>
                    <div style={{ paddingRight: "2em" }}>
                        <SubMenuLink link={"/SupportTickets"} text={t("navbar.suport.options.ticket_text")} />
                        <SubMenuLink link={"/faq"} text={t("navbar.suport.options.faq_text")} />
                        <SubMenuLink link={"/Chatbot"} text={t("navbar.suport.options.chat_text")} />
                        <SubMenuLink link="/DevelopAndIntegrate" text={t("navbar.suport.options.integrations_text")} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SubSuporteMob